import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap, LocPortal } from '@cm/core/localization';

const pathStart = 'Exam Scheduling|Appointment History|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.ExamAppointments,
	portal: 'CP' as LocPortal,
};

export type AppointmentHistoryLocName =
	| 'CPAppointmentHistoryLabelDate'
	| 'CPAppointmentHistoryLabelGroup'
	| 'CPAppointmentHistoryLabelName'
	| 'CPAppointmentHistoryLabelCode'
	| 'CPAppointmentHistoryLabelDeliveryProvider';

export const appointmentHistoryLocs: LocDefs<AppointmentHistoryLocName> = {
	CPAppointmentHistoryLabelDate: {
		defaultValue: 'Date',
		description: 'Column/field label for Appointment Date in appointment history',
		displayPath: `${pathStart}Date`,
		displayType: 'Label',
		...sharedProperties,
	},
	CPAppointmentHistoryLabelGroup: {
		defaultValue: 'Group',
		description: 'Column/field label for Exam Group in appointment history',
		displayPath: `${pathStart}Group`,
		displayType: 'Label',
		...sharedProperties,
	},
	CPAppointmentHistoryLabelName: {
		defaultValue: 'Name',
		description: 'Column/field label for Exam Name in appointment history',
		displayPath: `${pathStart}Name`,
		displayType: 'Label',
		...sharedProperties,
	},
	CPAppointmentHistoryLabelCode: {
		defaultValue: 'Code',
		description: 'Column/field label for Exam Code in appointment history',
		displayPath: `${pathStart}Code`,
		displayType: 'Label',
		...sharedProperties,
	},
	CPAppointmentHistoryLabelDeliveryProvider: {
		defaultValue: 'Delivery Provider',
		description: 'Column/field label for Delivery Provider in appointment history',
		displayPath: `${pathStart}Delivery Provider`,
		displayType: 'Label',
		legacyName: 'Exam.Appointments/ExamAppointments.Previous.FieldLabel.DeliveryProvider',
		...sharedProperties,
	},
};

export type AppointmentHistoryLocType = LocMap<AppointmentHistoryLocName>;
